// Libraries
import { enableProdMode } from '@angular/core';
import { ApiConfig } from './woopa-ui/api';

/**
 * Environment Providers
 */
let PROVIDERS: any[] = [
  // common env directives
];

// Depending on the env mode, enable prod mode or add debugging modules
if (process.env.ENV === 'build') {
  enableProdMode();

  // Production providers
  PROVIDERS = [
    ...PROVIDERS,
    {
      provide: ApiConfig,
      useValue: new ApiConfig({
        // Whatever origin served this page, not a hardcoded host. Rails now
        // serves the SPA and the API together, so they are always the same
        // origin: tbb-she.stg.rzr.ar in staging, the production host in
        // production, and one bundle works in both.
        //
        // It used to say https://api.seguridad.terminalbb.com.ar, which meant
        // the staging SPA called the PRODUCTION API. It only failed because
        // production's CORS rejected the staging origin. Had that allowed it,
        // staging would have been reading and writing production data.
        //
        // Not an empty string: ApiConfig does `config.urlAPI || <localhost>`
        // and '' is falsy, so a blank value silently falls back to localhost.
        urlAPI: window.location.origin,
        version: 1,
        headers: {}
      })
    }
  ];

// Development
} else {
  PROVIDERS = [
    ...PROVIDERS,
    {
      provide: ApiConfig,
      useValue: new ApiConfig({
        urlAPI: 'http://localhost:3000',
        version: 1,
        headers: {}
      })
    }
  ];
}

/**
 * Environment providers
 */
export const ENV_PROVIDERS = [
  ...PROVIDERS
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/environment.ts